import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import UIBuilder from "./UIBuilder";

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UIBuilder />
    </QueryClientProvider>
  );
}
